<template>
    <div id="ad005">
        <div class="top_part">
            <img class="top-back-img" src="@/assets/down-ad/ad005/1.png" alt="">
        </div>
        <div class="middle-part">
            <img src="@/assets/down-ad/ad005/2.png" alt="">
            <div @click="go" class="btn">点击下载金果子量化</div>
        </div>
        <div class="bottom-part">
            <img src="@/assets/down-ad/ad005/3.png" alt="">
        </div>
    </div>
</template>

<script>
import JgzLoading from '@/components/JgzLoading.vue'
export default {
    name: 'ProDownload04',
    data() {
        return {
            showLoading: true,
            maskViewShow: false,
            iosUrl: '',
            androidUrl: '',
        }
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        go() {
            window.open('https://misc.jinguozi.net/open-app?d=MTAzODFfQ1M1QVRI')
        }
    }
}
</script>

<style lang='less'>
#ad005 {
	height: auto;
	width: 100vw;
	// background: #FF8000;;
	// padding-top: 38px;
	background-size: 100% 100%;
	background-repeat: no-repeat;
    position: relative;
    img {
        pointer-events: none;
    }
    .top_part {
        width: 100vw;
        height: 1153px;
        position: relative;
        .top-back-img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100vw;
        }
    }
    .middle-part {
        position: relative;
        margin-top: -5px;
        img {
            width: 100vw;
        }
        .btn {
            position: absolute;
            width: 394px;
            height: 80px;
            background: #50C502;
            border-radius: 40px;
            top: 1053px;
            left: 179px;
            color: #FFFFFF;
            line-height: 80px;
            font-size: 24px;
            font-weight: bold;
            text-align: center;
        }
    }
    .bottom-part {
        margin-top: -8px;
        img {
            width: 100vw;
        }
    }
}
</style>
